<div class="h-100">
    <nb-card>
        <nb-card-header>{{ getHeader() }}</nb-card-header>
        <nb-card-body class="p-0">
            <div
                class="m-3 element"
                #fieldElement
                [class.highlighted]="highlightedFieldId === field.id"
                *ngFor="let field of fields"
                [ngSwitch]="field.fieldType"
            >
                <ng-container *ngSwitchCase="FieldType.NUMERIC">
                    <ngx-form-field-numeric
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsNumeric(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                        [checkValidation]="checkValidation"
                    ></ngx-form-field-numeric>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.TEXT">
                    <ngx-form-field-text
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsText(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                    ></ngx-form-field-text>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.CHECKBOX">
                    <ngx-form-field-checkbox
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsCheckbox(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                    ></ngx-form-field-checkbox>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.SINGLE_SELECT">
                    <ngx-form-field-single-select
                        [pageMode]="pageMode"
                        *ngIf="checkRenderField(field)"
                        [field]="field"
                        [result]="this.formService.extractResultsSingleSelect(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                    ></ngx-form-field-single-select>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.MULTI_SELECT">
                    <ngx-form-field-multi-select
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsMultiSelect(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                    ></ngx-form-field-multi-select>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.IMAGE">
                    <ngx-form-field-media
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsMedia(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                        [s3service]="s3service"
                    ></ngx-form-field-media>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.VIDEO">
                    <ngx-form-field-media
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsMedia(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                        [s3service]="s3service"
                    ></ngx-form-field-media>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.IMAGE_VIDEO">
                    <ngx-form-field-media
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsMedia(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                        [s3service]="s3service"
                    ></ngx-form-field-media>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.SIGNATURE">
                    <ngx-form-field-signature
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsSignature(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                        [assetFormId]="assetFormId"
                        [s3service]="s3service"
                    ></ngx-form-field-signature>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.TABLE">
                    <ngx-form-field-table
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsTable(field, results)"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                        [s3service]="s3service"
                    ></ngx-form-field-table>
                </ng-container>

                <ng-container *ngSwitchCase="FieldType.ISSUES">
                    <ngx-form-field-issues
                        *ngIf="checkRenderField(field)"
                        [pageMode]="pageMode"
                        [field]="field"
                        [result]="this.formService.extractResultsIssues(field, results)"
                        [results]="results"
                        [required]="getFieldRequired(field)"
                        [viewMode]="viewMode"
                        [cellType]="cellType"
                        [countOfDeficiency]="findInspectionDeficiencyCount(field)"
                        [fieldResultForm]="fieldResultForm"
                        (formFieldChangeEvent)="formFieldChangeEvent.emit($event)"
                        [checkValidation]="checkValidation"
                        (onLeadIconClick)="onLeadIconClick.emit($event)"
                        (onAddDeficiency)="onAddDeficiency.emit($event)"
                        [s3service]="s3service"
                    ></ngx-form-field-issues>
                </ng-container>
            </div>
        </nb-card-body>
    </nb-card>
</div>
